let language = {
    "301180": "The shop owner of this store does not belong to the current user",
    "302106": "The current user's email address is not activated",
    "302101": "The security check failed and the data is at risk of being tampered with, If you are the owner of this store and it's not listed in your account, please contact us for assistance.({{supportEmail}})",
};

export { language }